import AiStarIcon from "@redotech/redo-icons/ai-star.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { memo } from "react";
import * as styles from "./ask-redo-button.module.css";

type AskRedoButtonProps = { onClick: () => void };

const OrangeAiStarIcon = () => <AiStarIcon className={styles.icon} />;

export const AskRedoButton = memo(function AskRedoButton({
  onClick,
}: AskRedoButtonProps) {
  return (
    <RedoButton
      buttonClassName={styles.button}
      className="dark-mode"
      hierarchy="secondary"
      IconLeading={OrangeAiStarIcon}
      onClick={onClick}
      size="sm"
      text="Ask Redo"
    />
  );
});
